// src/views/cobrancas/CobrancasList.jsx
import React, { useState, useEffect, useCallback } from "react";
import boletosService   from "../../services/boletosService";
import cobrancasService    from "../../services/cobrancasService";
import EnviarBoletoModal  from "../../components/ui/EnviarBoletoModal";
import condominiosService  from "../../services/condominiosService";
import contasBancariasService from "../../services/contasBancariasService";
import contasContabeisService from "../../services/contasContabeisService";
import unidadesService     from "../../services/unidadesService";
import { useAuth } from "../../contexts/AuthContext";

const fmtM = v => Number(v||0).toLocaleString("pt-BR",{style:"currency",currency:"BRL"});
const fmtD = d => { try{ const s=String(d||"").split("T")[0]; return new Date(s+"T12:00:00").toLocaleDateString("pt-BR"); }catch{ return d||"—"; } };
const mesAtual = () => { const n=new Date(); return `${n.getFullYear()}-${String(n.getMonth()+1).padStart(2,"0")}`; };
const dtVencPadrao = () => { const n=new Date(); n.setDate(10); return `${n.getFullYear()}-${String(n.getMonth()+1).padStart(2,"0")}-${String(n.getDate()).padStart(2,"0")}`; };

const STATUS_GERACAO = {
  Preview:    {bg:"#FEF9C3",color:"#854D0E",label:"Preview"},
  Gerado:     {bg:"#DBEAFE",color:"#1E40AF",label:"Gerado"},
  EnvioCNAB:  {bg:"#F5F3FF",color:"#6D28D9",label:"Aguard. CNAB"},
  Registrado: {bg:"#DCFCE7",color:"#166534",label:"Registrado"},
  Cancelado:  {bg:"#F1F5F9",color:"var(--gray-400)",label:"Cancelado"},
};

const STATUS_BOLETO = {
  Pendente:   {bg:"#FEF9C3",color:"#854D0E"},
  Gerado:     {bg:"#DBEAFE",color:"#1E40AF"},
  Registrado: {bg:"#DCFCE7",color:"#166534"},
  Pago:       {bg:"#DCFCE7",color:"#166534"},
  Cancelado:  {bg:"#F1F5F9",color:"var(--gray-400)"},
  Erro:       {bg:"#FEE2E2",color:"#991B1B"},
};

export default function CobrancasList() {
  const { condominioAtivo } = useAuth();
  const [aba, setAba]             = useState("gerar");
  const [condominios, setCondominios] = useState([]);
  const [idCondo, setIdCondo]     = useState("");
  const [contas, setContas]       = useState([]);
  const [contasContabeis, setContasContabeis] = useState([]);
  const [unidades, setUnidades]   = useState([]);
  const [config, setConfig]       = useState({});
  const [vlrRateioBase,  setVlrRateioBase]  = useState("");
  const [rateioOrigemSalvo, setRateioOrigemSalvo] = useState(false);
  const [loadingRateio, setLoadingRateio] = useState(false);
  const [historico, setHistorico] = useState([]);
  const [loadingHist, setLoadingHist] = useState(false);

  // Formulário de geração
  const [tpGeracao, setTpGeracao] = useState("Mensal");
  const [competencia, setCompetencia] = useState(mesAtual());
  const [dtVenc, setDtVenc]       = useState(dtVencPadrao());
  const [idContaBancaria, setIdContaBancaria] = useState("");
  const [tpEnvio, setTpEnvio]     = useState("API");
  // Avulso
  const [descAvulso, setDescAvulso] = useState("");
  const [idContaContabilAvulso, setIdContaContabilAvulso] = useState("");
  const [vlrAvulso, setVlrAvulso] = useState("");
  const [tpRateioAvulso, setTpRateioAvulso] = useState("Igualitario");
  const [unidadesSel, setUnidadesSel] = useState([]);

  // Preview
  const [preview, setPreview]     = useState(null);
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [confirmando, setConfirmando] = useState(false);

  // Config modal
  const [showConfig,  setShowConfig]  = useState(false);
  const [showEnviar,  setShowEnviar]  = useState(false);
  const [enviarIds,   setEnviarIds]   = useState([]);
  const [showPixModal, setShowPixModal] = useState(false);
  const [pixBoletoId,  setPixBoletoId]  = useState(null);
  const [pixDtPag,     setPixDtPag]     = useState(new Date().toISOString().split("T")[0]);
  const [pixVlr,       setPixVlr]       = useState("");
  const [savingConfig, setSavingConfig] = useState(false);
  const [formConfig, setFormConfig] = useState({});

  // Detalhe geração
  const [geracaoDetalhe, setGeracaoDetalhe] = useState(null);
  const [itensDetalhe, setItensDetalhe] = useState([]);

  // Sync with navbar condominioAtivo — updates whenever user changes it
  useEffect(() => {
    if (condominioAtivo?.id) setIdCondo(String(condominioAtivo.id));
    else setIdCondo("");
  }, [condominioAtivo]);
  useEffect(() => {
    condominiosService.listar({limit:100}).then(r=>{
      setCondominios(r.data||[]);
    }).catch(()=>{});
  },[]);

  useEffect(() => {
    if(!idCondo) return;
    contasBancariasService.listar({idCondominio:idCondo,situacao:"ativo"}).then(r=>{
      setContas(r.data||[]);
      if(r.data?.length>0) setIdContaBancaria(String(r.data[0].id));
    }).catch(()=>{});
    contasContabeisService.listar({idCondominio:idCondo,situacao:"ativo",natureza:"Analitica"}).then(r=>setContasContabeis(r.data||[])).catch(()=>{});
    unidadesService.listar({idCondominio:idCondo,limit:500}).then(r=>setUnidades(r.data||[])).catch(()=>{});
    cobrancasService.buscarConfig(idCondo).then(r=>{ setConfig(r.data||{}); setFormConfig(r.data||{}); }).catch(()=>{});
    setPreview(null); setGeracaoDetalhe(null);
  },[idCondo]);

  const carregarHistorico = useCallback(async () => {
    if(!idCondo) return;
    setLoadingHist(true);
    try{ const r=await cobrancasService.listar({idCondominio:idCondo,limit:20}); setHistorico(r.data||[]); }catch{}
    setLoadingHist(false);
  },[idCondo]);

  useEffect(()=>{ if(aba==="historico") carregarHistorico(); },[aba,carregarHistorico]);

  const condoNome = condominios.find(c=>String(c.id)===String(idCondo))?.nmFantasia||"";
  const setFC = (f,v) => setFormConfig(p=>({...p,[f]:v}));

  const handleSalvarConfig = async () => {
    setSavingConfig(true);
    try{ await cobrancasService.salvarConfig(idCondo,formConfig); setConfig(formConfig); setShowConfig(false); alert("Configuração salva!"); }
    catch(e){ alert(e.message); }
    setSavingConfig(false);
  };

  const handlePreview = async () => {
    if(!idCondo)  return alert("Selecione o condomínio.");
    if(!dtVenc)   return alert("Informe a data de vencimento.");
    if(tpGeracao==="Mensal"&&!competencia) return alert("Informe o mês de referência.");
    // Avulso: desc/valor opcionais — pode usar apenas recorrentes do período
    setLoadingPreview(true); setPreview(null);
    try {
      const r = await cobrancasService.preview({
        idCondominio:idCondo, competencia, dtVencimentoPadrao:dtVenc,
        tpGeracao, descricao:descAvulso, idContaContabilAvulso, vlrTotalAvulso:vlrAvulso,
        tpRateioAvulso, idUnidadesSel:unidadesSel.length?unidadesSel:undefined,
      });
      setPreview(r);
    } catch(e){ alert(e.message); }
    setLoadingPreview(false);
  };

  const handleConfirmar = async () => {
    const qtd = preview?.itens?.filter(i=>i.incluir!==false).length || 0;
    const totalLote = preview?.itens?.reduce((a,i)=>a+(i.incluir!==false?parseFloat(i.vlrTotal||0):0),0) || 0;
    if (!preview) return;
    const msg =
      `Confirmar geração de ${qtd} boleto(s) — total ${fmtM(totalLote)}?\n\n` +
      `Método de envio: ${tpEnvio === "API" ? "API (registro automático)" : "CNAB (download de arquivo)"}\n` +
      `Após a confirmação, os boletos não podem ser recriados — apenas cancelados/reemitidos.`;
    if (!window.confirm(msg)) return;
    setConfirmando(true);
    try {
      const r = await cobrancasService.confirmar({
        idCondominio:idCondo, idContaBancaria, competencia,
        dtVencimentoPadrao:dtVenc, tpGeracao, descricao:descAvulso, idContaContabilAvulso,
        tpEnvio, tpRateioAvulso, vlrTotalAvulso:vlrAvulso,
        geradoPor:"Administrador", itens:preview.itens,
      });
      if(r.arquivoCNAB) {
        const blob=new Blob([r.arquivoCNAB.conteudo],{type:"text/plain"});
        const url=URL.createObjectURL(blob);
        const a=document.createElement("a"); a.href=url; a.download=r.arquivoCNAB.nome; a.click();
        URL.revokeObjectURL(url);
      }
      setPreview(null); setAba("historico"); await carregarHistorico();
      alert(r.message || `✅ ${qtd} boleto(s) gerado(s) com sucesso!`);
    } catch(e){ alert(e.message); }
    setConfirmando(false);
  };

  const handleMarcarRegistradoLote = async (geracaoId) => {
    if (!window.confirm("Marcar todos os boletos desta geração como Registrados no banco?")) return;
    try {
      // Busca ids dos boletos pendentes do lote
      const r = await cobrancasService.buscarItens(geracaoId);
      const ids = (r.data||[]).filter(i=>i.statusBoleto==="Gerado"&&i.idBoleto).map(i=>i.idBoleto);
      if (!ids.length) return alert("Nenhum boleto pendente nesta geração.");
      await Promise.all(ids.map(id=>boletosService.marcarRegistrado(id)));
      carregarHistorico();
      if (geracaoDetalhe?.id === geracaoId) {
        const r2 = await cobrancasService.buscarItens(geracaoId);
        setItensDetalhe(r2.data||[]);
      }
      alert(`${ids.length} boleto(s) marcado(s) como Registrado.`);
    } catch(e) { alert(e?.message||"Erro ao marcar."); }
  };

  const handleRegistrarAPI = async (idBoleto) => {
    if (!window.confirm("Registrar este boleto via API do banco?")) return;
    try {
      const r = await cobrancasService.registrarViaAPI([idBoleto]);
      const res = r.resultados?.[0];
      if (res?.sucesso) {
        alert("✅ Boleto registrado com sucesso!");
      } else {
        alert("❌ " + (res?.erro || res?.msg || "Erro ao registrar."));
      }
      carregarHistorico();
    } catch(e) { alert(e?.message || "Erro ao registrar via API."); }
  };

  const handleMarcarRegistrado = async (idBoleto) => {
    if (!window.confirm("Marcar este boleto como Registrado no banco?")) return;
    try {
      await boletosService.marcarRegistrado(idBoleto);
      carregarHistorico();
    } catch(e) { alert(e?.message||"Erro ao marcar."); }
  };

  const handleConfirmarPix = async () => {
    if (!pixBoletoId) return;
    try {
      await boletosService.confirmarPix(pixBoletoId, { dtPagamento:pixDtPag, vlrPago:pixVlr });
      setShowPixModal(false); setPixBoletoId(null); setPixVlr("");
      carregarHistorico();
    } catch(e) { alert(e?.message||"Erro ao confirmar."); }
  };

  const handleImprimir = async (idBoleto) => {
    try{
      const r=await cobrancasService.imprimirBoleto(idBoleto);
      const w=window.open("","_blank","width=820,height=900");
      w.document.write(r.html); w.document.close();
    }catch(e){alert(e.message);}
  };

  const handleImprimirLote = async (idGeracao) => {
    try{
      const r=await cobrancasService.imprimirLote(idGeracao);
      const w=window.open("","_blank","width=820,height=900");
      w.document.write(r.html); w.document.close();
    }catch(e){alert(e.message);}
  };

  const handleDetalhe = async (g) => {
    setGeracaoDetalhe(g);
    try{ const r=await cobrancasService.buscarItens(g.id); setItensDetalhe(r.data||[]); }catch{}
  };

  const toggleUnidade = (id) => setUnidadesSel(p=>p.includes(id)?p.filter(x=>x!==id):[...p,id]);
  const toggleTodas   = () => setUnidadesSel(unidadesSel.length===unidades.length?[]:unidades.map(u=>u.id));

  const editarItemPreview = (idx, campo, val) => {
    setPreview(p=>{
      const itens=[...p.itens];
      itens[idx]={...itens[idx],[campo]:val,editadoManualmente:true};
      // recalcula total
      const i=itens[idx];
      itens[idx].vlrTotal=parseFloat((
        parseFloat(i.vlrCota||0)+parseFloat(i.vlrFundoReserva||0)+
        parseFloat(i.vlrRecorrentes||0)+parseFloat(i.vlrAvulso||0)+
        parseFloat(i.vlrMultas||0)+parseFloat(i.vlrOutros||0)+
        parseFloat(i.vlrReserva||0)+
        parseFloat(i.vlrAjuste||0)-parseFloat(i.vlrDesconto||0)
      ).toFixed(2));
      return {...p,itens};
    });
  };


  // ── Carrega base do rateio (rateioContas) ──────────────────────────────────
  const carregarRateioBase = async (condo, comp) => {
    const tpCob = config?.tpCobranca || config?.cobCondominio;
    if (!tpCob?.includes('rateio') || !condo || !comp) return;
    setLoadingRateio(true);
    try {
      const r = await cobrancasService.getRateioBase(condo, comp);
      setVlrRateioBase(r.vlrBase > 0 ? String(r.vlrBase) : "");
      setRateioOrigemSalvo(r.salvo);
    } catch(e) { console.error(e); }
    setLoadingRateio(false);
  };

  const salvarRateioBase = async () => {
    if (!idCondo || !competencia || !vlrRateioBase) return;
    try {
      await cobrancasService.salvarRateioBase({
        idCondominio: idCondo, competencia,
        vlrBase: parseFloat(vlrRateioBase)||0,
        tpOrigem: "Manual"
      });
      setRateioOrigemSalvo(true);
    } catch(e) { console.error(e); }
  };

  const recalcularRateioBase = async () => {
    if (!idCondo || !competencia) return;
    setLoadingRateio(true);
    try {
      // Remove valor salvo e recalcula
      await cobrancasService.deletarRateioBase(idCondo, competencia).catch(()=>{});
      const r = await cobrancasService.getRateioBase(idCondo, competencia);
      setVlrRateioBase(r.vlrBase > 0 ? String(r.vlrBase) : "");
      setRateioOrigemSalvo(false);
    } catch(e) { console.error(e); }
    setLoadingRateio(false);
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title"><i className="bi bi-receipt me-2" style={{color:"var(--primary)",fontSize:22}}/>Cobranças</h1>
          <p className="page-subtitle">
            Geração de boletos mensais e avulsos
            {condoNome && (
              <span style={{marginLeft:8,padding:"2px 8px",background:"var(--bg-highlight)",
                borderRadius:10,fontSize:12,color:"var(--primary)",fontWeight:600}}>
                <i className="bi bi-building me-1"/>{condoNome}
              </span>
            )}
          </p>
        </div>
        <div className="d-flex gap-2 align-items-center flex-wrap">
          {idCondo&&<button className="btn btn-outline-secondary btn-sm" onClick={()=>setShowConfig(true)} title="Configurações financeiras">
            <i className="bi bi-gear"/> Config. Financeira
          </button>}
        </div>
      </div>

      {/* Sub-abas */}
      <div className="card">
        <div style={{borderBottom:"1px solid var(--gray-200)",padding:"0 16px",display:"flex",gap:4}}>
          {[{id:"gerar",label:"Nova Geração",icon:"bi-plus-circle"},{id:"historico",label:"Histórico",icon:"bi-clock-history"}].map(t=>(
            <button key={t.id} className="btn border-0 d-flex align-items-center gap-1"
              style={{fontSize:13,padding:"12px 14px",borderRadius:0,
                borderBottom:aba===t.id?"2px solid var(--primary)":"2px solid transparent",
                fontWeight:aba===t.id?600:400,color:aba===t.id?"var(--primary)":"var(--gray-500)",background:"transparent"}}
              onClick={()=>setAba(t.id)}>
              <i className={`bi ${t.icon}`}/>{t.label}
            </button>
          ))}
        </div>

        {/* ── ABA GERAR ── */}
        {aba==="gerar"&&(
          <div style={{padding:16}}>
            {!idCondo
              ?<div className="text-center py-5" style={{color:"var(--gray-400)"}}><i className="bi bi-buildings" style={{fontSize:36,display:"block",marginBottom:8}}/>Selecione um condomínio</div>
              :<>
                {/* Tipo de geração */}
                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-receipt"/> Tipo de Geração</div>
                  <div className="d-flex gap-3 mb-3">
                    {[{v:"Mensal",l:"Boleto Mensal",icon:"bi-calendar-month",desc:"Gera boletos para todas as unidades do mês"},{v:"Avulso",l:"Boleto Avulso",icon:"bi-file-earmark-plus",desc:"Cobrança pontual — obra, reforma, taxa extra"}].map(tp=>(
                      <div key={tp.v} onClick={()=>setTpGeracao(tp.v)}
                        style={{flex:1,border:`2px solid ${tpGeracao===tp.v?"var(--primary)":"var(--gray-200)"}`,borderRadius:10,padding:"14px 16px",cursor:"pointer",background:tpGeracao===tp.v?"#EFF6FF":"#fff"}}>
                        <div style={{display:"flex",alignItems:"center",gap:10}}>
                          <i className={`bi ${tp.icon}`} style={{fontSize:22,color:tpGeracao===tp.v?"var(--primary)":"var(--gray-400)"}}/>
                          <div>
                            <div style={{fontWeight:700,color:tpGeracao===tp.v?"var(--primary)":"var(--gray-700)"}}>{tp.l}</div>
                            <div style={{fontSize:12,color:"var(--gray-400)"}}>{tp.desc}</div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="row g-3">
                    {tpGeracao==="Mensal"&&(
                      <div className="col-md-3">
                        <label className="form-label">Mês de Referência <span className="required-mark">*</span></label>
                        <input type="month" className="form-control" value={competencia} onChange={e=>setCompetencia(e.target.value)}/>
                      </div>
                    )}

                    {/* Base do Rateio — só aparece para rateioContas */}
                    {(config?.tpCobranca==="rateioContas"||config?.cobCondominio==="rateioContas") && tpGeracao!=="Avulso" && (
                      <div className="col-12">
                        <div style={{background:"var(--bg-highlight)",borderRadius:10,padding:"14px 20px",border:"1px solid #BFDBFE"}}>
                          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                            <div style={{fontWeight:700,fontSize:13,color:"#1D4ED8"}}>
                              <i className="bi bi-calculator me-2"/>Base do Rateio de Contas
                            </div>
                            <div style={{display:"flex",gap:8,alignItems:"center"}}>
                              {rateioOrigemSalvo && (
                                <span style={{fontSize:11,background:"var(--bg-success-soft)",color:"#166534",padding:"2px 8px",borderRadius:10,fontWeight:600}}>
                                  <i className="bi bi-floppy me-1"/>Valor salvo
                                </span>
                              )}
                              <button className="btn btn-outline-secondary btn-sm"
                                onClick={recalcularRateioBase} disabled={loadingRateio}
                                title="Recalcular do banco">
                                {loadingRateio
                                  ? <span className="spinner-border spinner-border-sm"/>
                                  : <><i className="bi bi-arrow-repeat me-1"/>Recalcular</>}
                              </button>
                            </div>
                          </div>
                          <div style={{display:"flex",gap:12,alignItems:"center"}}>
                            <div style={{flex:1}}>
                              <label className="form-label" style={{fontSize:12,color:"var(--gray-500)"}}>
                                Total de Despesas — Base do Rateio
                                <span style={{fontSize:11,marginLeft:8,color:"var(--gray-400)"}}>
                                  ({config?.rateioBaseMes==="Anterior"?"Mês Anterior":"Mês Vigente"})
                                </span>
                              </label>
                              <div className="input-group">
                                <span className="input-group-text">R$</span>
                                <input
                                  type="number" step="0.01" min="0"
                                  className="form-control"
                                  value={vlrRateioBase}
                                  onChange={e=>{ setVlrRateioBase(e.target.value); setRateioOrigemSalvo(false); }}
                                  onBlur={salvarRateioBase}
                                  placeholder="0,00"
                                  style={{fontWeight:700,fontSize:15}}
                                />
                              </div>
                              <small style={{color:"var(--gray-400)",fontSize:11}}>
                                <i className="bi bi-info-circle me-1"/>
                                Edite o valor e clique fora do campo para salvar. Use "Recalcular" para buscar as despesas do banco.
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {tpGeracao==="Avulso"&&(
                      <>
                        <div className="col-md-5">
                          <label className="form-label">
                            Conta Contábil <span className="required-mark">*</span>
                          </label>
                          <select className="form-select"
                            value={idContaContabilAvulso}
                            onChange={e=>{
                              setIdContaContabilAvulso(e.target.value);
                              // Auto-preenche descrição com nome da conta se vazio
                              if (!descAvulso) {
                                const ct = contasContabeis.find(x=>String(x.id)===e.target.value);
                                if (ct) setDescAvulso(ct.descConta||ct.nmConta||"");
                              }
                            }}>
                            <option value="">— Selecione a conta —</option>
                            {contasContabeis
                              .filter(ct=>["ReceitaOrdinaria","ReceitaExtraordinaria","FundoReserva","Outro"].includes(ct.tpConta))
                              .map(ct=>(
                                <option key={ct.id} value={ct.id}>
                                  {ct.classificacaoContabil ? `${ct.classificacaoContabil} — ` : ""}{ct.descConta||ct.nmConta}
                                </option>
                              ))}
                          </select>
                          {contasContabeis.filter(ct=>["ReceitaOrdinaria","ReceitaExtraordinaria","FundoReserva","Outro"].includes(ct.tpConta)).length===0 && (
                            <small style={{color:"#C2410C",fontSize:11}}>
                              <i className="bi bi-exclamation-triangle me-1"/>
                              Nenhuma conta de receita no Plano de Contas. Cadastre em Plano de Contas.
                            </small>
                          )}
                        </div>
                        <div className="col-md-5">
                          <label className="form-label">Descrição / Complemento</label>
                          <input className="form-control" value={descAvulso}
                            onChange={e=>setDescAvulso(e.target.value)}
                            placeholder="Ex: Reforma da fachada — Fev/2026"/>
                        </div>
                        <div className="col-md-3">
                          <label className="form-label">Valor Total (R$) <span className="required-mark">*</span></label>
                          <div className="input-group"><span className="input-group-text">R$</span>
                            <input className="form-control" type="number" step="0.01" value={vlrAvulso} onChange={e=>setVlrAvulso(e.target.value)}/></div>
                        </div>
                        <div className="col-md-4">
                          <label className="form-label">Tipo de Rateio</label>
                          <select className="form-select" value={tpRateioAvulso} onChange={e=>setTpRateioAvulso(e.target.value)}>
                            <option value="Igualitario">Igualitário (partes iguais)</option>
                            <option value="FracaoIdeal">Por Fração Ideal</option>
                            <option value="ValorFixo">Valor Fixo por Unidade</option>
                          </select>
                        </div>
                      </>
                    )}
                    <div className="col-md-3">
                      <label className="form-label">Vencimento Padrão <span className="required-mark">*</span></label>
                      <input type="date" className="form-control" value={dtVenc} onChange={e=>setDtVenc(e.target.value)}/>
                      <small style={{fontSize:11,color:"var(--gray-400)"}}>Usado quando unidade/cond. não tem dia configurado</small>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Conta Bancária</label>
                      <select className="form-select" value={idContaBancaria} onChange={e=>setIdContaBancaria(e.target.value)}>
                        <option value="">— Selecione —</option>
                        {contas.map(c=><option key={c.id} value={c.id}>{c.nmConta} — {c.banco||""}</option>)}
                      </select>
                      {config.idContaBancariaPadrao&&<small style={{fontSize:11,color:"#166534"}}><i className="bi bi-check-circle me-1"/>Padrão do condomínio pré-selecionado</small>}
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Método de Envio</label>
                      <div className="d-flex gap-2">
                        {[{v:"API",l:"API (tempo real)"},{v:"CNAB",l:"CNAB (arquivo)"}].map(m=>(
                          <button key={m.v} type="button" className={`btn flex-fill ${tpEnvio===m.v?"btn-primary":"btn-outline-secondary"}`} style={{fontSize:12}} onClick={()=>setTpEnvio(m.v)}>{m.l}</button>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Seleção de unidades para avulso */}
                {tpGeracao==="Avulso"&&(
                  <div className="form-section">
                    <div className="form-section-title d-flex justify-content-between">
                      <span><i className="bi bi-house-door"/> Unidades ({unidadesSel.length===0?"Todas":unidadesSel.length+" selecionada(s)"})</span>
                      <button className="btn btn-outline-secondary btn-sm" onClick={toggleTodas} style={{fontSize:12}}>
                        {unidadesSel.length===unidades.length?"Desmarcar Todas":"Selecionar Todas"}
                      </button>
                    </div>
                    <div style={{display:"flex",flexWrap:"wrap",gap:6,maxHeight:180,overflowY:"auto",padding:4}}>
                      {unidades.map(u=>{
                        const sel=unidadesSel.length===0||unidadesSel.includes(u.id);
                        return (
                          <div key={u.id} onClick={()=>toggleUnidade(u.id)}
                            style={{padding:"4px 12px",borderRadius:16,fontSize:12,fontWeight:600,cursor:"pointer",border:"2px solid",
                              borderColor:sel?"var(--primary)":"var(--gray-200)",
                              background:sel?"var(--primary)":"#fff",color:sel?"#fff":"var(--gray-500)"}}>
                            {u.unidade}{u.bloco?`/B${u.bloco}`:""}
                          </div>
                        );
                      })}
                    </div>
                    <small style={{fontSize:11,color:"var(--gray-400)"}}>Clique para desmarcar. Sem seleção = todas as unidades ativas.</small>
                  </div>
                )}

                {/* Botão calcular */}
                <div className="d-flex justify-content-end gap-2 mb-3">
                  <button className="btn btn-primary btn-lg" onClick={handlePreview} disabled={loadingPreview||!idCondo}>
                    {loadingPreview?<><span className="spinner-border spinner-border-sm me-2"/>Calculando...</>
                    :<><i className="bi bi-calculator me-2"/>Calcular Preview</>}
                  </button>
                </div>

                {/* ── PREVIEW ── */}
                {preview&&(
                  <div className="form-section">
                    <div className="form-section-title d-flex justify-content-between align-items-center">
                      <span><i className="bi bi-table"/> Preview — {preview.resumo?.qtdUnidades} unidade(s)</span>
                      <div style={{display:"flex",gap:12,fontSize:13}}>
                        <span style={{color:"var(--primary)",fontWeight:700}}>Total: {fmtM(preview.resumo?.vlrTotalGeral)}</span>
                      </div>
                    </div>

                    {/* Alertas */}
                    {preview.alertas?.length>0&&(
                      <div style={{background:"#FFF7ED",border:"1px solid #FED7AA",borderRadius:8,padding:"10px 14px",marginBottom:12}}>
                        <div style={{fontWeight:600,color:"#C2410C",marginBottom:4,fontSize:13}}>
                          <i className="bi bi-exclamation-triangle me-2"/>{preview.alertas.length} alerta(s) — geração permitida
                        </div>
                        {preview.alertas.map((a,i)=><div key={i} style={{fontSize:12,color:"#C2410C"}}>• {a}</div>)}
                      </div>
                    )}

                    <div className="table-responsive" style={{maxHeight:420,overflowY:"auto"}}>
                      <table className="table table-custom" style={{fontSize:12}}>
                        <thead>
                          <tr>
                            <th style={{width:30}}><input type="checkbox" checked={preview.itens?.every(i=>i.incluir!==false)}
                              onChange={()=>{const all=preview.itens?.every(i=>i.incluir!==false);setPreview(p=>({...p,itens:p.itens.map(i=>({...i,incluir:!all}))}))}}/></th>
                            <th>Unid.</th><th>Condômino</th><th>Vencimento</th>
                            <th style={{textAlign:"right"}}>Cota Cond.</th>
                            <th style={{textAlign:"right"}}>F.Reserva</th>
                            <th style={{textAlign:"right"}}>Recorrentes</th>
                            <th style={{textAlign:"right"}}>Multas</th>
                            <th style={{textAlign:"right"}}>Água/Gás</th>
                            <th style={{textAlign:"right"}}>Reservas</th>
                            {tpGeracao==="Avulso" && <th style={{textAlign:"right"}}>
                              {contasContabeis.find(x=>String(x.id)===idContaContabilAvulso)?.descConta || "Avulso"}
                            </th>}
                            <th style={{textAlign:"right"}}>Ajuste(+/-)</th>
                            <th style={{textAlign:"right",fontWeight:700,color:"var(--primary)"}}>Total</th>
                            <th style={{width:20}}></th>
                          </tr>
                        </thead>
                        <tbody>
                          {preview.itens?.map((item,idx)=>(
                            <tr key={idx} style={{
                              background:item.incluir===false?"#F1F5F9":item.fracaoIdealZerada?"#FFFBEB":"",
                              opacity:item.incluir===false?.5:1
                            }}>
                              <td><input type="checkbox" checked={item.incluir!==false}
                                onChange={()=>editarItemPreview(idx,"incluir",item.incluir===false?true:false)}/></td>
                              <td style={{fontWeight:700,color:"var(--primary)"}}>
                                {item.unidade}{item.bloco?`/B${item.bloco}`:""}
                                {item.fracaoIdealZerada&&<i className="bi bi-exclamation-triangle-fill text-warning ms-1" title="Fração ideal zerada"/>}
                                {item.boletoDuplicado&&<i className="bi bi-x-circle-fill text-danger ms-1" title="Boleto já gerado para esta competência"/>}
                              </td>
                              <td style={{maxWidth:120,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{item.nmCondomino||"—"}</td>
                              <td>{fmtD(item.dtVencimento)}</td>
                              <td style={{textAlign:"right"}}>
                                {fmtM(item.vlrCota)}
                                {item.vlrProporcional&&<div style={{fontSize:10,color:"#6D28D9"}}>proporcional</div>}
                              </td>
                              <td style={{textAlign:"right"}}>{item.cobFundoReserva==="Nao"?<span style={{fontSize:10,color:"var(--gray-400)"}}>—</span>:fmtM(item.vlrFundoReserva)}</td>
                              <td style={{textAlign:"right"}}>
                                {item.vlrRecorrentes>0?fmtM(item.vlrRecorrentes):<span style={{color:"var(--gray-400)"}}>—</span>}
                                {item.detalheRecorrentes?.length>0&&(
                                  <div style={{fontSize:10,color:"var(--gray-500)"}}>
                                    {item.detalheRecorrentes.map((r,j)=><div key={j}>· {r.nmDespesa}</div>)}
                                  </div>
                                )}
                              </td>
                              <td style={{textAlign:"right"}}>
                                {item.vlrMultas>0?<span style={{color:"#DC2626",fontWeight:600}}>{fmtM(item.vlrMultas)}</span>:<span style={{color:"var(--gray-400)"}}>—</span>}
                                {item.detalheMultas?.length>0&&(
                                  <div style={{fontSize:10,color:"#DC2626"}}>
                                    {item.detalheMultas.map((m,j)=><div key={j}>· {m.descricao}</div>)}
                                  </div>
                                )}
                              </td>
                              <td style={{textAlign:"right"}}>
                                {item.vlrOutros>0?fmtM(item.vlrOutros):<span style={{color:"var(--gray-400)"}}>—</span>}
                                {item.detalheOutros?.length>0&&(
                                  <div style={{fontSize:10,color:"var(--gray-500)"}}>
                                    {item.detalheOutros.map((o,j)=><div key={j}>· {o.descricao}</div>)}
                                  </div>
                                )}
                              </td>
                              <td style={{textAlign:"right"}}>
                                {item.vlrReserva>0
                                  ? <span title={(item.detalheReservas||[]).map(r=>`${r.descricao}: ${fmtM(r.vlr)}`).join("\n")}
                                      style={{cursor:"help",borderBottom:"1px dashed #94A3B8"}}>
                                      {fmtM(item.vlrReserva)}
                                    </span>
                                  : <span style={{color:"var(--gray-400)"}}>—</span>}
                              </td>
                              {tpGeracao==="Avulso"&&<td style={{textAlign:"right"}}>{item.vlrAvulso>0?fmtM(item.vlrAvulso):<span style={{color:"var(--gray-400)"}}>—</span>}</td>}
                              <td>
                                <input type="number" step="0.01" value={item.vlrAjuste||0}
                                  onChange={e=>editarItemPreview(idx,"vlrAjuste",parseFloat(e.target.value)||0)}
                                  style={{width:70,fontSize:12,border:"1px solid var(--gray-200)",borderRadius:4,padding:"1px 4px",textAlign:"right"}}/>
                              </td>
                              <td style={{textAlign:"right",fontWeight:700,color:"var(--primary)",fontSize:13}}>{fmtM(item.vlrTotal)}</td>
                              <td>
                                {item.editadoManualmente&&<i className="bi bi-pencil-fill" style={{fontSize:10,color:"#F59E0B"}} title="Editado manualmente"/>}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr style={{fontWeight:700,background:"var(--gray-50)"}}>
                            <td colSpan={4} style={{fontSize:13}}>TOTAL GERAL</td>
                            <td style={{textAlign:"right"}}>{fmtM(preview.itens?.reduce((a,i)=>a+(i.incluir!==false?parseFloat(i.vlrCota||0):0),0))}</td>
                            <td style={{textAlign:"right"}}>{fmtM(preview.itens?.reduce((a,i)=>a+(i.incluir!==false?parseFloat(i.vlrFundoReserva||0):0),0))}</td>
                            <td style={{textAlign:"right"}}>{fmtM(preview.itens?.reduce((a,i)=>a+(i.incluir!==false?parseFloat(i.vlrRecorrentes||0):0),0))}</td>
                            <td style={{textAlign:"right",color:"#DC2626"}}>{fmtM(preview.itens?.reduce((a,i)=>a+(i.incluir!==false?parseFloat(i.vlrMultas||0):0),0))}</td>
                            <td style={{textAlign:"right"}}>{fmtM(preview.itens?.reduce((a,i)=>a+(i.incluir!==false?parseFloat(i.vlrOutros||0):0),0))}</td>
                            <td style={{textAlign:"right"}}>{fmtM(preview.itens?.reduce((a,i)=>a+(i.incluir!==false?parseFloat(i.vlrReserva||0):0),0))}</td>
                            {tpGeracao==="Avulso"&&<td style={{textAlign:"right"}}>{fmtM(preview.itens?.reduce((a,i)=>a+(i.incluir!==false?parseFloat(i.vlrAvulso||0):0),0))}</td>}
                            <td></td>
                            <td style={{textAlign:"right",color:"var(--primary)",fontSize:14,fontWeight:700}}>{fmtM(preview.itens?.reduce((a,i)=>a+(i.incluir!==false?parseFloat(i.vlrTotal||0):0),0))}</td>
                            <td></td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <div style={{fontSize:12.5,color:"var(--gray-500)"}}>
                        <span>{preview.itens?.filter(i=>i.incluir!==false).length} de {preview.itens?.length} unidade(s) incluídas</span>
                        {tpEnvio==="CNAB"&&<span style={{marginLeft:12,color:"#6D28D9"}}><i className="bi bi-download me-1"/>Arquivo CNAB será gerado para download</span>}
                      </div>
                      <div className="d-flex gap-2">
                        <button className="btn btn-outline-secondary" onClick={()=>setPreview(null)}>
                          <i className="bi bi-arrow-left"/> Voltar
                        </button>
                        <button className="btn btn-success btn-lg" onClick={handleConfirmar} disabled={confirmando}>
                          {confirmando?<><span className="spinner-border spinner-border-sm me-2"/>Gerando boletos...</>
                          :<><i className="bi bi-check2-circle me-2"/>Confirmar e Gerar Boletos</>}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </>
            }
          </div>
        )}

        {/* ── ABA HISTÓRICO ── */}
        {aba==="historico"&&(
          <>
            <div className="table-responsive">
              <table className="table table-custom">
                <thead>
                  <tr><th>Referência</th><th>Tipo</th><th>Conta Bancária</th><th>Método</th>
                    <th style={{textAlign:"right"}}>Boletos</th>
                    <th style={{textAlign:"right"}}>Total</th>
                    <th>Status</th><th>Data</th><th style={{width:120}}>Ações</th></tr>
                </thead>
                <tbody>
                  {loadingHist?<tr><td colSpan={9} className="text-center py-4"><span className="spinner-border spinner-border-sm text-primary"/></td></tr>
                  :historico.length===0?<tr><td colSpan={9} className="text-center py-4" style={{color:"var(--gray-400)"}}>Nenhuma geração encontrada</td></tr>
                  :historico.map(g=>(
                    <React.Fragment key={g.id}>
                      <tr style={{background:geracaoDetalhe?.id===g.id?"#EFF6FF":""}}>
                        <td style={{fontWeight:600}}>{g.competencia||g.descricao||"—"}</td>
                        <td><span style={{background:g.tpGeracao==="Avulso"?"#F5F3FF":"#EFF6FF",color:g.tpGeracao==="Avulso"?"#6D28D9":"var(--primary)",padding:"2px 8px",borderRadius:10,fontSize:11,fontWeight:600}}>{g.tpGeracao}</span></td>
                        <td style={{fontSize:12.5}}>{g.nmContaBancaria||"—"}</td>
                        <td><span style={{background:"var(--gray-100)",padding:"2px 7px",borderRadius:10,fontSize:11}}>{g.tpEnvio}</span></td>
                        <td style={{textAlign:"right",fontWeight:600}}>{g.qtdBoletos}</td>
                        <td style={{textAlign:"right",fontWeight:700,color:"var(--primary)"}}>{fmtM(g.vlrTotal)}</td>
                        <td>
                          {(()=>{const s=STATUS_GERACAO[g.status]||STATUS_GERACAO.Gerado;return(
                            <span style={{...s,padding:"2px 8px",borderRadius:12,fontSize:11,fontWeight:600}}>{s.label}</span>
                          );})()}
                        </td>
                        <td style={{fontSize:12}}>{fmtD(g.createdAt)}</td>
                        <td>
                          <div className="table-actions">
                            <button className="btn btn-outline-secondary btn-sm btn-icon" title="Ver detalhes"
                              onClick={()=>geracaoDetalhe?.id===g.id?setGeracaoDetalhe(null):handleDetalhe(g)}>
                              <i className={`bi bi-chevron-${geracaoDetalhe?.id===g.id?"up":"down"}`}/>
                            </button>
                            <button className="btn btn-outline-success btn-sm btn-icon" title="Enviar todos por E-mail/WhatsApp"
                            onClick={e=>{
                              e.stopPropagation();
                              const ids = (g.itens||[]).filter(i=>i.idBoleto).map(i=>i.idBoleto);
                              if(!ids.length) return alert("Nenhum boleto disponível nesta geração.");
                              setEnviarIds(ids); setShowEnviar(true);
                            }}>
                            <i className="bi bi-send-fill"/>
                          </button>
                          <button className="btn btn-outline-secondary btn-sm btn-icon" title="Imprimir todos"
                              onClick={()=>handleImprimirLote(g.id)}>
                              <i className="bi bi-printer"/>
                            </button>
                            {g.arquivoCNAB&&<button className="btn btn-outline-secondary btn-sm btn-icon" title="Baixar CNAB"
                              onClick={async()=>{try{const r=await cobrancasService.baixarCNAB(g.id);const b=new Blob([r.conteudo],{type:"text/plain"});const u=URL.createObjectURL(b);const a=document.createElement("a");a.href=u;a.download=r.nome;a.click();}catch(e){alert(e.message);}}}>
                              <i className="bi bi-download"/>
                            </button>}
                            {g.status==="Gerado"&&(
                              <button className="btn btn-outline-info btn-sm btn-icon"
                                title="Marcar todos como Registrado no banco"
                                onClick={e=>{e.stopPropagation();handleMarcarRegistradoLote(g.id);}}>
                                <i className="bi bi-bank"/>
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                      {/* Detalhe dos itens */}
                      {geracaoDetalhe?.id===g.id&&(
                        <tr>
                          <td colSpan={9} style={{padding:"0 16px 12px",background:"#F8FAFF"}}>
                            <table style={{width:"100%",fontSize:12}}>
                              <thead>
                                <tr style={{color:"var(--gray-500)",fontWeight:600}}>
                                  <th style={{padding:"6px 8px"}}>Unid.</th><th style={{padding:"6px 8px"}}>Condômino</th>
                                  <th style={{padding:"6px 8px"}}>Vencimento</th><th style={{padding:"6px 8px",textAlign:"right"}}>Total</th>
                                  <th style={{padding:"6px 8px"}}>Boleto</th><th style={{padding:"6px 8px"}}>Ações</th>
                                </tr>
                              </thead>
                              <tbody>
                                {itensDetalhe.map(item=>(
                                  <tr key={item.id}>
                                    <td style={{padding:"4px 8px",fontWeight:700,color:"var(--primary)"}}>{item.unidade}{item.bloco?`/B${item.bloco}`:""}</td>
                                    <td style={{padding:"4px 8px"}}>{item.nmCondomino||"—"}</td>
                                    <td style={{padding:"4px 8px"}}>{fmtD(item.dtVencimento)}</td>
                                    <td style={{padding:"4px 8px",textAlign:"right",fontWeight:700}}>{fmtM(item.vlrTotal)}</td>
                                    <td style={{padding:"4px 8px"}}>
                                      {(()=>{const s=STATUS_BOLETO[item.statusBoleto]||STATUS_BOLETO.Gerado;return(
                                        <span style={{...s,padding:"2px 7px",borderRadius:10,fontSize:11,fontWeight:600}}>{item.statusBoleto}</span>
                                      );})()}
                                      {item.erroMsg&&<div style={{fontSize:10,color:"#991B1B"}}>{item.erroMsg}</div>}
                                    </td>
                                    <td style={{padding:"4px 8px"}}>
                                      {item.idBoleto&&<>
                                        <button className="btn btn-outline-success btn-sm" 
                                          style={{fontSize:11,padding:"2px 8px"}}
                                          onClick={e=>{e.stopPropagation();setEnviarIds([item.idBoleto]);setShowEnviar(true);}}>
                                          <i className="bi bi-send-fill me-1"/>Enviar
                                        </button>
                                        <button className="btn btn-outline-secondary btn-sm" style={{fontSize:11,padding:"2px 8px"}}
                                        onClick={()=>handleImprimir(item.idBoleto)}>
                                        <i className="bi bi-printer me-1"/>Imprimir
                                      </button>
                                      {item.statusBoleto==="Gerado"&&(
                                        <button className="btn btn-outline-info btn-sm" style={{fontSize:11,padding:"2px 8px"}}
                                          onClick={e=>{e.stopPropagation();handleMarcarRegistrado(item.idBoleto);}}>
                                          <i className="bi bi-bank me-1"/>Reg.Banco
                                        </button>
                                      )}
                                      {item.statusBoleto==="Gerado"&&item.tpRegistro==="API"&&(
                                        <button className="btn btn-outline-primary btn-sm" style={{fontSize:11,padding:"2px 8px"}}
                                          onClick={e=>{e.stopPropagation();handleRegistrarAPI(item.idBoleto);}}>
                                          <i className="bi bi-cloud-upload me-1"/>Reg.API
                                        </button>
                                      )}
                                      {(item.statusBoleto==="Gerado"||item.statusBoleto==="Registrado")&&(
                                        <button className="btn btn-outline-success btn-sm" style={{fontSize:11,padding:"2px 8px"}}
                                          onClick={e=>{e.stopPropagation();setPixBoletoId(item.idBoleto);setPixVlr(String(item.vlrBoleto||""));setShowPixModal(true);}}>
                                          <i className="bi bi-qr-code me-1"/>PIX
                                        </button>
                                      )}
                                      </>}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>

      {/* ── MODAL CONFIG FINANCEIRA ── */}
      {showConfig&&(
        <div className="modal fade show d-block" style={{background:"rgba(0,0,0,.55)"}} tabIndex="-1">
          <div className="modal-dialog modal-lg modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <div className="d-flex align-items-center gap-3">
                  <div style={{width:38,height:38,background:"rgba(255,255,255,.15)",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center"}}>
                    <i className="bi bi-gear" style={{fontSize:18,color:"#fff"}}/>
                  </div>
                  <div>
                    <h5 className="modal-title mb-0">Configuração Financeira</h5>
                    <small style={{color:"rgba(255,255,255,.6)",fontSize:12}}>{condoNome}</small>
                  </div>
                </div>
                <button className="btn-close btn-close-white" onClick={()=>setShowConfig(false)}/>
              </div>
              <div className="modal-body">
                {/* Cota Condominial */}
                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-cash-coin"/> Cota Condominial</div>
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label">Tipo de Cobrança</label>
                      <select className="form-select" value={formConfig.tpCobranca||"ValorFixo"} onChange={e=>setFC("tpCobranca",e.target.value)}>
                        <option value="ValorFixo">Valor Fixo</option>
                        <option value="RateioFracaoIdeal">Rateio por Fração Ideal</option>
                        <option value="RateioIgualitario">Rateio Igualitário</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">{formConfig.tpCobranca==="RateioFracaoIdeal"||formConfig.tpCobranca==="RateioIgualitario"?"Valor Total a Ratear":"Valor Fixo"} (R$)</label>
                      <div className="input-group"><span className="input-group-text">R$</span>
                        <input className="form-control" type="number" step="0.01" value={formConfig.vlrCondominio||""} onChange={e=>setFC("vlrCondominio",e.target.value)}/></div>
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">Dia Vencimento</label>
                      <input className="form-control" type="number" min="0" max="28" value={formConfig.diaVencimento||0} onChange={e=>setFC("diaVencimento",e.target.value)}/>
                      <small style={{fontSize:11,color:"var(--gray-400)"}}>0 = usa data da geração</small>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Conta Contábil — Cota Condominial</label>
                      <select className="form-select" value={formConfig.idCtCotaCondominial||""} onChange={e=>setFC("idCtCotaCondominial",e.target.value)}>
                        <option value="">— Sem vínculo —</option>
                        {contasContabeis.filter(c=>["ReceitaOrdinaria","ReceitaExtraordinaria","Outro"].includes(c.tpConta)).map(c=>(
                          <option key={c.id} value={c.id}>{c.classificacaoContabil} — {c.descConta}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                {/* Fundo de Reserva */}
                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-piggy-bank"/> Fundo de Reserva</div>
                  <div className="row g-3">
                    <div className="col-md-3">
                      <label className="form-label">Cobrar Fundo de Reserva</label>
                      <div className="form-check form-switch mt-2">
                        <input className="form-check-input" type="checkbox" id="cobrarFundo"
                          checked={formConfig.cobrarFundoReserva==1||formConfig.cobrarFundoReserva===true}
                          onChange={e=>setFC("cobrarFundoReserva",e.target.checked?1:0)}/>
                        <label className="form-check-label" htmlFor="cobrarFundo">{formConfig.cobrarFundoReserva?"Sim":"Não"}</label>
                      </div>
                    </div>
                    {(formConfig.cobrarFundoReserva==1||formConfig.cobrarFundoReserva===true)&&<>
                      <div className="col-md-3">
                        <label className="form-label">Tipo do Fundo</label>
                        <select className="form-select" value={formConfig.tpFundoReserva||"ValorFixo"} onChange={e=>setFC("tpFundoReserva",e.target.value)}>
                          <option value="ValorFixo">Valor Fixo</option>
                          <option value="Percentual">Percentual da Cota</option>
                        </select>
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">{formConfig.tpFundoReserva==="Percentual"?"Percentual (%)":"Valor Fixo (R$)"}</label>
                        <input className="form-control" type="number" step="0.01" value={formConfig.vlrFundoReserva||""} onChange={e=>setFC("vlrFundoReserva",e.target.value)}/>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Conta Contábil — Fundo de Reserva</label>
                        <select className="form-select" value={formConfig.idCtFundoReserva||""} onChange={e=>setFC("idCtFundoReserva",e.target.value)}>
                          <option value="">— Sem vínculo —</option>
                          {contasContabeis.filter(c=>["FundoReserva","PassivoCirculante","Outro"].includes(c.tpConta)).map(c=>(
                            <option key={c.id} value={c.id}>{c.classificacaoContabil} — {c.descConta}</option>
                          ))}
                        </select>
                      </div>
                    </>}
                  </div>
                </div>

                {/* Conta bancária padrão */}
                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-bank"/> Conta Bancária Padrão</div>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label">Conta para Recebimento — Cota Condominial</label>
                      <select className="form-select" value={formConfig.idContaBancariaPadrao||""} onChange={e=>setFC("idContaBancariaPadrao",e.target.value)}>
                        <option value="">— Selecionar na geração —</option>
                        {contas.map(c=><option key={c.id} value={c.id}>{c.nmConta} — {c.banco||""}</option>)}
                      </select>
                      <small style={{fontSize:11,color:"var(--gray-400)"}}>Pré-selecionada automaticamente na geração de boletos</small>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Conta para Recebimento — Fundo de Reserva</label>
                      <select className="form-select" value={formConfig.idContaBancariaFundoReserva||""} onChange={e=>setFC("idContaBancariaFundoReserva",e.target.value)}>
                        <option value="">— Mesma da cota condominial —</option>
                        {contas.map(c=><option key={c.id} value={c.id}>{c.nmConta} — {c.banco||""}</option>)}
                      </select>
                      <small style={{fontSize:11,color:"var(--gray-400)"}}>Se não selecionada, usa a mesma conta da cota</small>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-outline-secondary" onClick={()=>setShowConfig(false)}><i className="bi bi-x-circle"/> Cancelar</button>
                <button className="btn btn-primary" onClick={handleSalvarConfig} disabled={savingConfig}>
                  {savingConfig?<><span className="spinner-border spinner-border-sm me-2"/>Salvando...</>:<><i className="bi bi-check-circle"/> Salvar Configuração</>}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showPixModal && (
        <div className="modal fade show" style={{display:"block",background:"rgba(0,0,0,.5)"}} onClick={()=>setShowPixModal(false)}>
          <div className="modal-dialog modal-sm" onClick={e=>e.stopPropagation()}>
            <div className="modal-content">
              <div className="modal-header" style={{background:"var(--bg-success-soft)"}}>
                <h6 className="modal-title" style={{color:"#166534"}}>✅ Confirmar Pagamento PIX</h6>
                <button type="button" className="btn-close" onClick={()=>setShowPixModal(false)}/>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label fw-semibold" style={{fontSize:13}}>Data do Pagamento</label>
                  <input type="date" className="form-control" value={pixDtPag}
                    onChange={e=>setPixDtPag(e.target.value)}/>
                </div>
                <div className="mb-3">
                  <label className="form-label fw-semibold" style={{fontSize:13}}>Valor Recebido (R$)</label>
                  <input type="number" className="form-control" value={pixVlr} step="0.01"
                    onChange={e=>setPixVlr(e.target.value)} placeholder="0,00"/>
                </div>
                <small className="text-muted" style={{fontSize:11}}>
                  Confirme o valor no extrato bancário antes de salvar.
                </small>
              </div>
              <div className="modal-footer">
                <button className="btn btn-outline-secondary btn-sm" onClick={()=>setShowPixModal(false)}>Cancelar</button>
                <button className="btn btn-success btn-sm" onClick={handleConfirmarPix}>
                  <i className="bi bi-check-lg me-1"/>Confirmar Pagamento
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showEnviar && (
        <EnviarBoletoModal
          ids={enviarIds}
          onClose={()=>setShowEnviar(false)}
          onSent={()=>{ setTimeout(()=>setShowEnviar(false), 2000); carregarHistorico(); }}
        />
      )}
    </div>
  );
}
